import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CutTextComponent } from 'src/app/components/misc/cut-text/cut-text.component';
import { Customer } from 'src/app/models/customer/Customer';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';

@Component({
  selector: 'app-customer-status-badge',
  templateUrl: './customer-status-badge.component.html',
  styleUrl: './customer-status-badge.component.scss',
  standalone: true,
  imports: [SHARED_IMPORTS, CutTextComponent]
})
export class CustomerStatusBadgeComponent {
  private router = inject(Router);

  @Input({ required: true }) customer!: Customer;

  @Input() disabled = false;

  @Input() clickable = true;

  @Output() changeIsBlocked = new EventEmitter<boolean>();

  handleOnMouseDown() {
    if (this.disabled || !this.clickable) {
      return;
    }

    this.changeIsBlocked.emit(!this.customer.isBlocked);
  }

  navigateToCustomer(customerId: number) {
    if (this.disabled || !this.clickable) {
      return;
    }

    this.router.navigate(['/customers', customerId]);
  }
}
